<template>
  <section class="people_center_like">
    <div class="like">
      <div class="head">
        <ul>
          <li>
            <span :class="{active:step==='video'}" @click="changeStep('video')">
              {{$t('global.喜欢的作品')}}
              <b>{{likeVideoCount}}</b>
            </span>
          </li>
          <li>
            <span :class="{active:step==='article'}" @click="changeStep('article')">
              {{$t('global.喜欢的文章')}}
              <b>{{likeArticleCount}}</b>
            </span>
          </li>
        </ul>
      </div>
      <div class="like-video-list" v-if="step === 'video'">
        <empty
          v-if="!loading&&!likeVideoCount "
          url="/static/v2/peopleCenter/video_empty.png"
          :content="$t('global.还没有喜欢的作品')"
          :_style="{width:'88px',height:'88px'}"
        />
        <ul v-else>
          <li v-for="item in likeVideoList" :key="item.videoId">
            <video-card :item="item" :language="language" />
          </li>
        </ul>
      </div>
      <div class="like-article-list" v-if="step === 'article'">
        <empty
          v-if="!likeArticleCount "
          url="/static/v2/peopleCenter/article_empty.png"
          :content="$t('global.还没有喜欢的文章')"
          :_style="{width:'88px',height:'88px'}"
        />
        <ul v-else>
          <li v-for="item in likeArticleList" :key="item.articleId">
            <article-card :item="item" :language="language" />
          </li>
        </ul>
      </div>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
      <no-more v-if="!hasNextPage && (likeArticleList.length||likeVideoList.length)" />
    </div>
  </section>
</template>

<script>
import VideoCard from "@/components/v2/peopleCenter/VideoCard2";
import ArticleCard from "@/components/v2/peopleCenter/ArticleCard";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import Empty from "@/components/v2/Empty";
import NoMore from "@/components/v2/NoMore";

import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  metaInfo() {
    return {
      title: this.$t("global.喜欢") + " | MANA"
    };
  },
  components: {
    VideoCard,
    ArticleCard,
    Reload,
    Loading,
    Empty,
    NoMore
  },
  data() {
    return {
      step: "video",
      loadError: false,
      userId: null,
      loading: false,
      hasNextPage: false,
      hasNextPage1: false,
      hasNextPage2: false,
      showLikeSort: false,
      likeVideoList: [],
      likeArticleList: [],
      likeVideoCount: 0,
      likeArticleCount: 0,
      pageIndex: 1,
      pageSize: 20
    };
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.userId = this.$route.params.userId;
      this.getLikeVideoList();
      this.getLikeArticleList();
    },
    changeStep(step) {
      if (this.step !== step) {
        this.step = step;
        this.pageIndex = 1;
        this.likeVideoList = [];
        this.likeArticleList = [];
        if (step === "video") {
          this.getLikeVideoList();
        } else {
          this.getLikeArticleList();
        }
      }
    },
    getLikeVideoList() {
      this.loading = true;
      const url = `/api/mobile/u/getLikeVideoList`;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.likeVideoList = [];
          }
          this.hasNextPage1 = res.data.hasNextPage;
          this.likeVideoCount = res.data.totalRecord;
          this.likeVideoList = [...this.likeVideoList, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    getLikeArticleList() {
      this.loading = true;
      const url = `/api/mobile/u/getLikeArticleList`;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.likeArticleList = [];
          }
          this.hasNextPage2 = res.data.hasNextPage;
          this.likeArticleCount = res.data.totalRecord;
          this.likeArticleList = [...this.likeArticleList, ...res.data.list];
        } else {
          this.loadError = true;
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
        }
      });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 150) {
        this.hasNextPage = this.step === "video"?this.hasNextPage1:this.hasNextPage2;
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          if (this.step === "video") {
            this.getLikeVideoList();
          } else {
            this.getLikeArticleList();
          }
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.people_center_like {
  .like {
    padding-bottom: 120px;

    .head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      ul {
        display: flex;
        flex-direction: row;
        padding: 30px 0;

        li {
          padding-right: 30px;

          span {
            cursor: pointer;
            font-size: 15px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #B8B8B8;

            &.active {
              color: #0A0A0A;

              b {
                color: #666;
              }
            }

            b {
              font-size: 14px;
              font-family: NunitoSans-SemiBold, NunitoSans;
              font-weight: 600;
              color: #B8B8B8;
            }
          }
        }
      }
    }

    .like-video-list {
      padding-bottom: 20px;

      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        li {
          width: 350px;
          padding-bottom: 30px;
        }
      }
    }

    .like-article-list {
      padding-bottom: 25px;

      ul {
        display: flex;
        flex-direction: column;

        li {
          padding: 25px 0;
          border-bottom: 1px solid #EBEBEB;

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/step/Like.vue